import { format } from 'date-fns';
import { DateRange } from './DateRange';
import { getAggregationLevel } from './getAggregationLevel';
import { MonitoringDataParams } from '../types';

export const getRequestParams = (
  dateRange: DateRange | undefined | null,
  includeEnergyAllocation = false,
): MonitoringDataParams | undefined => {
  if (!dateRange) {
    return undefined;
  }

  const startPlainDatetime = format(dateRange.startDate, "yyyy-MM-dd'T'HH:mm:ss");
  const endPlainDatetime = format(dateRange.endDate, "yyyy-MM-dd'T'HH:mm:ss");

  const baseParams = {
    start_time: startPlainDatetime,
    end_time: endPlainDatetime,
    aggregation_level: getAggregationLevel(dateRange.zoomLevel),
  };
  const params = includeEnergyAllocation
    ? {
        ...baseParams,
        include_energy_allocation: 'true',
      }
    : baseParams;

  return params;
};

export default getRequestParams;
